// web/src/main.tsx — נקודת הכניסה (D-245).
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/app.css";
import "./styles/shell.css";

// 🆕 10.10 — אחרי פריסה, דפדפן שמחזיק עמוד ישן מבקש קבצי מסך שכבר לא קיימים בשרת ⇒ מסך ריק.
//    (נמדד 10.10: OccurrenceCard-DPcnhIUf.js מהפריסה הקודמת — השרת החזיר את דף הבית במקום הקובץ.)
//    Vite משדר vite:preloadError כשטעינת מסך נכשלת ⇒ טוענים את העמוד מחדש פעם אחת (⛔ לולאה: סימון ל-30 שניות).
window.addEventListener("vite:preloadError", (e) => {
  const KEY = "atida-reload-after-deploy";
  let last = 0;
  try { last = Number(sessionStorage.getItem(KEY) || 0); } catch { /* אחסון חסום — ממשיכים */ }
  if (Date.now() - last < 30_000) return;          // כבר נטען מחדש עכשיו — ⛔ לולאה; השגיאה תוצג כרגיל
  try { sessionStorage.setItem(KEY, String(Date.now())); } catch { /* אחסון חסום */ }
  e.preventDefault();
  location.reload();
});

// 🆕 11.10 — הדפדפן שומר את דף הכניסה במטמון, ולכן אחרי פריסה הוא ממשיך להריץ גרסה ישנה (בלי שגיאה — רק בלי היכולות החדשות).
//    (נמדד 11.10: אחרי פריסה ורענון — עדיין index ישן.) בכל טעינה, וכשחוזרים ללשונית: בודקים מול השרת את שם הקובץ הראשי;
//    השתנה ⇒ טעינה מחדש פעם אחת (אותו סימון כמו למעלה — ⛔ לולאה).
function checkVersion() {
  const mine = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/index-"]')?.getAttribute("src") ?? "";
  if (!mine) return;                                   // שרת הפיתוח — אין קובץ ראשי עם חותמת
  // 🔑 cache: "reload" — מביא מהשרת וגם מעדכן את המטמון, כך שהטעינה מחדש תקבל את הדף החדש (no-store לא מעדכן).
  fetch("/", { cache: "reload" }).then((r) => r.text()).then((t) => {
    const live = t.match(/\/assets\/index-[\w-]+\.js/)?.[0];
    if (!live || mine.endsWith(live)) return;
    const KEY = "atida-reload-after-deploy";
    let last = 0;
    try { last = Number(sessionStorage.getItem(KEY) || 0); } catch { /* חסום */ }
    if (Date.now() - last < 30_000) return;
    try { sessionStorage.setItem(KEY, String(Date.now())); } catch { /* חסום */ }
    location.reload();
  }).catch(() => { /* אין רשת — ממשיכים בגרסה הנוכחית */ });
}
checkVersion();
document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") checkVersion(); });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
